import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import cx from 'classnames';
import useIsActive from './internal/useIsActive';
import UIRouterLink from './UIRouterLink';
export default function UIRouterNavLink(props) {
  const {
    activeClassName,
    activeStyle,
    children,
    className,
    exact,
    style,
    to
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["activeClassName", "activeStyle", "children", "className", "exact", "style", "to"]);

  const active = useIsActive(to, exact);
  const classes = cx(className, activeClassName && {
    [activeClassName]: active
  });
  return /*#__PURE__*/_jsx(UIRouterLink, Object.assign({}, rest, {
    "aria-current": active ? 'page' : undefined,
    className: classes,
    to: to,
    style: Object.assign({}, style, {}, active ? activeStyle : null),
    children: children
  }));
}
UIRouterNavLink.propTypes = Object.assign({}, UIRouterLink.propTypes, {
  activeClassName: PropTypes.string,
  activeStyle: PropTypes.object,
  className: PropTypes.string,
  exact: PropTypes.bool.isRequired,
  style: PropTypes.object.isRequired
});
UIRouterNavLink.defaultProps = Object.assign({}, UIRouterLink.defaultProps, {
  exact: false,
  style: {}
});